import { render, staticRenderFns } from "./KpiCollection.vue?vue&type=template&id=8098ca38&scoped=true&"
import script from "./KpiCollection.vue?vue&type=script&lang=js&"
export * from "./KpiCollection.vue?vue&type=script&lang=js&"
import style0 from "./KpiCollection.vue?vue&type=style&index=0&id=8098ca38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8098ca38",
  null
  
)

export default component.exports